module.exports = __webpack_public_path__ + "src/img/stylemarks/stylemarks-image-2.52566.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/stylemarks/stylemarks-image-2.png
// module id = 258
// module chunks = 0